import { Button, styled } from '@mui/material'

import { theme } from 'styles/theme'

type WrapperProps = {
  isExpandedMobileMenu: boolean
}

export const Wrapper = styled('div')<WrapperProps>(
  ({ isExpandedMobileMenu }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 22,
    backgroundColor: theme.palette.neutral[800],
    width: '90%',
    overflowY: 'auto',
    overflowX: 'hidden',
    overscrollBehavior: 'contain',
    WebkitOverflowScrolling: 'touch',
    paddingBottom: 'env(safe-area-inset-bottom, 0px)',
    zIndex: 800,
    height: isExpandedMobileMenu ? 'calc(100dvh - 120px)' : 0,
    transition: 'height 0.5s ease-in-out'
  })
)

export const BalanceButton = styled(Button)(() => ({
  ['&:focus']: {
    borderColor: 'black'
  },
  ['&:hover, &:focus']: {
    background: 'none'
  },
  alignItems: 'flex-start',
  border: '1px solid transparent',
  cursor: 'pointer',
  flexDirection: 'column'
}))

export const AccountDetails = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  width: '100%',
  gap: '12px'
}))

export const MenuItem = styled('div')(() => ({
  display: 'flex',
  gap: 10,
  alignItems: 'center',
  padding: '8px 0',
  width: '100%',
  cursor: 'pointer',
  ':hover': {
    backgroundColor: '#E9EBE9'
  }
}))
